export class PremiumTermsAndConditionsPartyModel  {
    public cellNumber: string;
    public firstName: string;
    public surname: string;
    public idNumber: string;
    public guid: string;
}

